import { isEmpty, omit } from 'lodash'
import omitDeep from 'omit-deep-lodash'
import { detailedDiff } from 'deep-object-diff'
import { TopicVersionType } from '../../../../graphql/private/PrivateSchemaTypes'

const prepareForComparison = (version: any, elementsField: string) => {
  const omitGenericFields = ['id', '__typename', 'updated_at']
  const omitVersionFields = [
    'id',
    'edit_token',
    'number_quizzes',
    'publishedElements',
    'version'
  ]
  if (version.topic_type === TopicVersionType.scorm) {
    omitVersionFields.push('scormCourse')
  }
  const omitFileDetailsFields = ['cdnUrl']

  return {
    ...omit(version, omitGenericFields.concat(omitVersionFields)),
    elements: version[elementsField].map((element) => {
      return {
        ...omit(element, omitGenericFields.concat(['duration', 'documents'])),
        data: {
          ...omit(element.data, 'job'),
          media: omitDeep(element.data?.media, ['cdnUrl']),
          options: omitDeep(element.data?.options, [
            ...omitGenericFields,
            'created_at',
            'other'
          ]),
          fileDetails: omit(element.data?.fileDetails, omitFileDetailsFields)
        },
        quizOptions: element.quizOptions.map((o) => omit(o, omitGenericFields))
      }
    })
  }
}

export const draftIsEqualPublished = (currentVersion, draftVersion) => {
  if (!currentVersion) {
    return false
  }

  const draftToCompare = prepareForComparison(draftVersion, 'elements')
  const publishedToCompare = prepareForComparison(
    currentVersion,
    'publishedElements'
  )
  const diff: any = detailedDiff(publishedToCompare, draftToCompare)

  return isEmpty(diff.updated) && isEmpty(diff.added) && isEmpty(diff.deleted)
}
